module.exports = __webpack_public_path__ + "static/img/ys_btn1.1adee63.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/role3/control/ys_btn1.png
// module id = at8Q
// module chunks = 7